import { render } from "./SoftwarePage.vue?vue&type=template&id=6166ee2c&scoped=true"
import script from "./SoftwarePage.vue?vue&type=script&lang=js"
export * from "./SoftwarePage.vue?vue&type=script&lang=js"

import "./SoftwarePage.vue?vue&type=style&index=0&id=6166ee2c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6166ee2c"]])

export default __exports__